import * as types from "./types";
import { clubsApi } from "@apiService";

export const getClubsData = (slug) => {
  return {
    type: types.GET_CLUBS_DATA,
    payload: clubsApi.getClubss(slug),
  };
};
